import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { CookieBannerTextWrapper, CookieBannerWrapper, CookieBannerButtonsWrapper, CookieBannerHeadline, CookieBannerAcceptButton, CookieBannerDeclineButton } from '../StyledComponents/Global/CookieBanner'

import { deleteCookies, trackGAEvent } from '../utilities/tracking'
import { PRIVACY_POLICY } from '../../constants/routes'

export const COOKIE_STORAGE_KEY = 'fai-cookie-consent'
export const COOKIE_STORAGE_DATE_KEY = 'fai-cookie-date'
const ANALYTICS_CONSENT_TYPE = 'cookieconsent_analytics'

class CookieBanner extends Component {
    constructor(props) {
        super(props)

        const storageItem = window.localStorage.getItem(COOKIE_STORAGE_KEY)
        this.state = {
            cookieConsent: parseInt(storageItem, 10),
        }

        this.onDeclineCookies = this.onDeclineCookies.bind(this)
        this.onAcceptCookies = this.onAcceptCookies.bind(this)
    }

    onAcceptCookies() {
        const acceptDate = Date.now()
        window.localStorage.setItem(COOKIE_STORAGE_KEY, 1)
        window.localStorage.setItem(COOKIE_STORAGE_DATE_KEY, acceptDate)
        this.setState({ cookieConsent: acceptDate })
    }

    onDeclineCookies() {
        window.localStorage.setItem(COOKIE_STORAGE_KEY, 0)
        window.localStorage.setItem(COOKIE_STORAGE_DATE_KEY, Date.now())
        window.gaOptout()
        this.setState({ cookieConsent: 0 })
        deleteCookies()
    }

    render() {
        const { cookieConsent } = this.state
        const consentDate = parseInt(window.localStorage.getItem(COOKIE_STORAGE_DATE_KEY), 10)

        const oneYearAgo = Date.now() - (1000 * 60 * 60 * 24 * 365)

        if (Number.isNaN(cookieConsent) || Number.isNaN(consentDate) || consentDate < oneYearAgo) {
            deleteCookies()
            if (window.location.pathname === PRIVACY_POLICY) {
                return null
            }

            return (
                <CookieBannerWrapper>
                    <CookieBannerHeadline>Diese Website verwendet Cookies</CookieBannerHeadline>
                    <CookieBannerTextWrapper>
                        {'Wir verwenden Cookies, um die Zugriffe auf unsere Website im Rahmen einer Studie für eine Masterarbeit  zu analysieren. Außerdem geben wir Informationen zu Ihrer Verwendung unserer Website an unsere Partner für Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen, die Sie ihnen bereitgestellt haben oder die sie im Rahmen ihrer Nutzung der Dienste gesammelt haben. Sie akzeptieren unsere Cookies, wenn sie fortfahren diese Website zu nutzen. Um an der Studie teilnehmen zu können, werden Cookies vorausgesetzt. Ihre Einwilligung können Sie '}
                        <Link style={{ color: 'var(--fai-text-color)', textDecoration: 'underline' }} to={`${PRIVACY_POLICY}#analytics`}>hier</Link>
                        {' jederzeit widerrufen. Weitere Informationen finden Sie in der '}
                        <Link style={{ color: 'var(--fai-text-color)', fontWeight: 'bold' }} to={PRIVACY_POLICY}>Datenschutzerklärung</Link>
                    </CookieBannerTextWrapper>
                    <CookieBannerButtonsWrapper>
                        <CookieBannerDeclineButton onClick={this.onDeclineCookies}>
                            Ablehnen
                        </CookieBannerDeclineButton>
                        <CookieBannerAcceptButton color="success" onClick={this.onAcceptCookies}>OK</CookieBannerAcceptButton>
                    </CookieBannerButtonsWrapper>
                </CookieBannerWrapper>
            )
        } else if (cookieConsent === 1) {
            trackGAEvent(ANALYTICS_CONSENT_TYPE, null)
        }

        return null
    }
}

export default withRouter(CookieBanner)



// WEBPACK FOOTER //
// ./src/components/Global/CookieBanner.js